import { z } from "zod";

export const roles = ["ADMIN", "USER"] as const;

// UK/international-friendly phone validation
export const phoneSchema = z
  .string()
  .trim()
  .transform((val) => val.replace(/[^\d+]/g, ""))
  .refine((val) => /^\+?\d{7,15}$/.test(val), {
    message: "Enter a valid phone number",
  });

export const userFormSchema = z.object({
  firstName: z.string().trim().min(1, "First name is required").max(50),

  lastName: z.string().trim().min(1, "Last name is required").max(50),

  pin: z.string().regex(/^\d{6}$/, "PIN must be exactly 6 digits"),

  role: z.enum(roles).catch("USER"),

  email: z.email("Invalid email address"),

  // REQUIRED phone number
  contact1: phoneSchema,

  // OPTIONAL phone number
  contact2: phoneSchema.optional().or(z.literal("")),

  rank: z.string().trim().max(100).optional(),
});

export type UserForm = z.infer<typeof userFormSchema>;
